// choices/roomChoices.js
const roomChoicesSrb = [
  { label: "Дневна соба 🛋️", value: "living-room" },
  { label: "Кухиња 🎛️", value: "kitchen" },
  { label: "Трпезарија 🍴", value: "dining-room" },
  { label: "Спаваћа соба 🛏️", value: "bedroom" },
  { label: "Купатило 🛁", value: "bathroom" },
  { label: "Дечија соба 👶", value: "kids-room" },

  { label: "Тинејџерска соба 👦", value: "teen-room" },
];

export default roomChoicesSrb;
